import { Address, RankCode } from "@/types";
import { IUserInfo } from "./user.types";

export class UserInfo implements IUserInfo {
  uid: string; // 사용자 식별자
  memberName: string; // 사용자 이름
  clientUid: string; // 소속사 uid
  clientName: string; // 소속사
  loginId: string; // 아이디
  email: string; // 이메일
  employeeNo: string; // 사번
  alias: string; // 닉네임
  phone: string; // 휴대폰번호
  deptName: string; // 부서
  bpName: string; // 협력사
  dutyNote: string; // 담당업무
  address: Address; // 집주소
  majorNoticeYn: boolean; // 중요 알림 설정 수신여부
  rankCode: RankCode; // 정규직, 협력사 구분하는 코드
  workTimeCode: string; // 근무 형태 구분 코드
  workTimeName: string; // 근무 형태 구분명
  bookBlockEndDtm?: string; // 예약불가 상태 만료 일시
  boardBlockEndDtm?: string; // 탑승불가 상태 만료 일시
  passwordReuseCount: number;
  isShuttleBoardBlocked: boolean; // 사내셔틀 탑승 차단 여부

  constructor(data: IUserInfo) {
    this.uid = data.uid;
    this.memberName = data.memberName;
    this.clientUid = data.clientUid;
    this.clientName = data.clientName;
    this.loginId = data.loginId;
    this.email = data.email;
    this.employeeNo = data.employeeNo;
    this.alias = data.alias;
    this.phone = data.phone;
    this.deptName = data.deptName;
    this.bpName = data.bpName;
    this.dutyNote = data.dutyNote;
    this.address = data.address;
    this.majorNoticeYn = data.majorNoticeYn;
    this.rankCode = data.rankCode;
    this.workTimeCode = data.workTimeCode;
    this.workTimeName = data.workTimeName;
    this.passwordReuseCount = data.passwordReuseCount;
    this.bookBlockEndDtm = data.bookBlockEndDtm;
    this.boardBlockEndDtm = data.boardBlockEndDtm;
    this.isShuttleBoardBlocked = data.isShuttleBoardBlocked;
  }
}
